
import './App.css';
import { Navigate, Route, HashRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import AnnualAssessmentPaymentComponent from "./components/payments/assessment-payment/AnnualAssessmentPaymentComponent.tsx"
import AnnualAssessmentPaymentProcessingComponent from "./components/payments/assessment-payment/AnnualAssessmentPaymentProcessingComponent.tsx"
import AnnualAssessmentPaymentConfirmationComponent from './components/payments/assessment-payment/AnnualAssessmentPaymentConfirmationComponent.tsx';
import WC12PaymentComponent from './components/payments/wc12-payment/WC12PaymentComponent.tsx';
import WC12PaymentProcessingComponent from './components/payments/wc12-payment/WC12PaymentProcessingComponent.tsx';
import WC12PaymentConfirmationComponent from './components/payments/wc12-payment/WC12PaymentConfirmationComponent.tsx';
import PaymentLink from './components/payments/common/PaymentLink.tsx';
import TokenExpiredPageComponent from './components/payments/common/TokenExpiredPageComponent.tsx';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // PrimeReact Theme
import 'primereact/resources/primereact.min.css';
const App: React.FC = () => {
  return (
       <div>
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Navigate to="/assesmentpayments" replace />} />
            <Route path="/assesmentpayments" element={<AnnualAssessmentPaymentComponent />} />
            <Route path="/paymentprocessing" element={<AnnualAssessmentPaymentProcessingComponent />} />
            <Route path="/paymentresponseconfirmation" element={<AnnualAssessmentPaymentConfirmationComponent />} />
            <Route path="/paymenttokenexpired" element={<TokenExpiredPageComponent />} />
            <Route path="/wc12payments" element={<WC12PaymentComponent />} />
            <Route path="/wc12paymentprocessing" element={<WC12PaymentProcessingComponent />} />
            <Route path="/wc12paymentconfirmation" element={<WC12PaymentConfirmationComponent />} />
           </Routes>
           </div>
      </div>
      </div>
  );
}

export default App;
